var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            modal: true,
            width: "698px",
            "before-close": _vm.closeDialog,
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("div", { staticClass: "dialog-title-title" }, [
                _vm._v("选择封面"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-title-upload" },
                [
                  _vm.deleteButton
                    ? _c("span", { on: { click: _vm.deleteImage } }, [
                        _c("i", { staticClass: "el-icon-delete" }),
                        _vm._v("删除"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload",
                      attrs: {
                        action: _vm.fileUrl,
                        "on-success": _vm.handleSuccess,
                        headers: _vm.myHeaders,
                        "show-file-list": false,
                        "before-upload": _vm.handleUpload,
                        data: _vm.uploadData,
                        multiple: "",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-upload2" }),
                      _vm._v("上传封面图\n        "),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "image-preview" }, [
                  _c("div", { staticClass: "image-preview-con" }, [
                    _c("img", {
                      attrs: {
                        src:
                          _vm.data.cover === "" || _vm.isImage
                            ? _vm.defaultImg
                            : _vm.data.cover,
                        alt: "",
                      },
                    }),
                    _vm._v(" "),
                    _vm.data.cover === "" || _vm.isImage
                      ? _c(
                          "div",
                          {
                            staticClass: "public-img",
                            class: _vm.colorBtn ? "color-withe" : "color-black",
                          },
                          [
                            _c("p", { staticClass: "title" }, [
                              _vm._v(_vm._s(_vm.data.name)),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "content" }, [
                              _vm._v(_vm._s(_vm.data.info)),
                            ]),
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "public-img",
                            class:
                              _vm.data.color === "#FFFFFF"
                                ? "color-withe"
                                : "color-black",
                          },
                          [
                            _c("p", { staticClass: "title" }, [
                              _vm._v(_vm._s(_vm.data.name)),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "content" }, [
                              _vm._v(_vm._s(_vm.data.info)),
                            ]),
                          ]
                        ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 18 } }, [
                _c("div", { staticClass: "image-list" }, [
                  _c(
                    "ul",
                    { staticClass: "image-list-ul" },
                    _vm._l(_vm.imageArray, function (item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          class: (index + 1) % _vm.column == 0 ? "mActive" : "",
                          on: {
                            click: function ($event) {
                              return _vm.checkImage(index, item)
                            },
                          },
                        },
                        [
                          _c("el-image", {
                            attrs: { src: item.thumb_dir, lazy: "" },
                          }),
                          _vm._v(" "),
                          _vm.data.cover === "" || _vm.isImage
                            ? _c("i", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: index == _vm.imgIndex,
                                    expression: "index == imgIndex",
                                  },
                                ],
                                staticClass: "el-icon-success image-success",
                                class: _vm.colorBtn ? "active" : "",
                              })
                            : _c("i", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      index ==
                                      _vm.getFindIndex(
                                        _vm.imageArray,
                                        "thumb_dir",
                                        _vm.data.cover
                                      ),
                                    expression:
                                      "index == getFindIndex(imageArray, 'thumb_dir', data.cover)",
                                  },
                                ],
                                staticClass: "el-icon-success image-success",
                                class:
                                  _vm.data.color == "#FFFFFF" ? "active" : "",
                              }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-left" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "page-size": _vm.where.limit,
                        "current-page": _vm.where.page,
                        layout: "prev, pager, next",
                        total: _vm.total,
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.pageChange,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.closeDialog } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("public.ok")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }